/* eslint semi: 1, react/prop-types:1 */

import React from 'react';
import ScreenshotComponent from './home-screenshot-component';
import image0 from '../images/image0.png';
import image1 from '../images/image1.png';
import image2 from '../images/image2.png';
import image3 from '../images/image3.png';
import image4 from '../images/image4.png';
import image5 from '../images/image5.png';
import image6 from '../images/image6.png';
import image7 from '../images/image7.png';
import image8 from '../images/image8.png';
import image9 from '../images/image9.png';

const screenshotArray = [
    {
        src: image0,
        description: 'Enter text from any language and Literacy Starter will build a character list showing how often each letter is used along with a word list showing word usage.'
    },
    {
        src: image1,
        description: 'Literacy Starter provides the tools necessary to process and correctly divide words from any language into syllables.'
    },
    {
        src: image2,
        description: 'Rules can be added to handle language exceptions in order to customize the algorithm for handling your specific language.'
    },
    {
        src: image3,
        description: 'Literacy Starter then helps you build primers and readers in a very short amount of time by providing you with very powerful tools to aid in the task.'
    },
    {
        src: image4,
        description: 'You design lesson plans and have tools to make sure nothing is missed in the teaching.'
    },
    {
        src: image5,
        description: 'Keyword pages are for teaching new syllables to the students.'
    },
    {
        src: image6,
        description: 'Reading pages are for the students to put their new skills into practice.'
    },
    {
        src: image7,
        description: 'Once the primers and readers are done, you can then export them to LibreOffice (.odg files).'
    },
    {
        src: image8,
        description: 'Booklets (whether primers or readers) can be printed to PDF and sent directly to the printers.'
    },
    {
        src: image9,
        description: 'Flashcards can be exported and printed as well to be used in teaching.'
    }
];

const Home = () => {

    const screenshotComponents = screenshotArray.map((s, i) => (
        <ScreenshotComponent key={`image${i}`} idx={i} imageSrc={s.src} description={s.description} />
    ));

    return (
        <div>
            {screenshotComponents}
        </div>
    );
};

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/home.js
 **/